import React, { Fragment, useState } from "react"
import { useInputValue } from "../../hooks/useInputValue"
import { Inner, Section, Title } from "./styles"
import YouTube from "react-youtube"

export const Video = ({ title, paragraph }) => {
  function _onReady(event) {
    // access to player in all event handlers via event.target
    // event.target.mute();
  }

  function _onEnd(event) {
    event.target.playVideo()
  }

  const videoOptions = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      controls: 1,
      mute: 1,
      rel: 0,
      showinfo: 0,
    },
    playerFullVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      controls: 0,
      mute: 1,
      rel: 0,
      showinfo: 0,
    },
  }

  return (
    <Section>
      <Inner>
        <Title>{title}</Title>
        <div className="video-responsive">
          <YouTube
            videoId="5NbRjLx69Yk"
            opts={videoOptions}
            className="video_iframe"
            onReady={_onReady}
            onEnd={_onEnd}
            id="video_iframe"
          />
        </div>
      </Inner>
    </Section>
  )
}
